/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ size: NonNullable<unknown> }} Filesize_Bytes1Inputs */

const en_filesize_bytes1 = /** @type {(inputs: Filesize_Bytes1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.size} bytes`)
};

/**
* | output |
* | --- |
* | "{size} bytes" |
*
* @param {Filesize_Bytes1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const filesize_bytes1 = /** @type {((inputs: Filesize_Bytes1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filesize_Bytes1Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_filesize_bytes1(inputs)
});
export { filesize_bytes1 as "fileSize_bytes" }